let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("gVKM4")).then(() => parcelRequire('fWUAL'));